import { normalizeFileName } from './normalize-file-name';

/**
 * `normalizeFileName` throws on a name with no extension. Uploading such a file is a
 * user mistake, not a crash, so fall back to the raw name for comparison purposes and
 * let the upload itself report the problem.
 */
const safeNormalize = (name: string): string => {
  try {
    return normalizeFileName(name);
  } catch {
    return name;
  }
};

const basename = (path: string): string => path.split('/').pop() || path;

/**
 * Names among `picked` that would overwrite something in `existing`.
 *
 * Returns the ORIGINAL picked names — that is what the conflict modal shows the user —
 * but compares on normalised basenames, which is what would actually be written. Note
 * that normalisation is a no-op for code extensions (`.py`, `.ts`, `.json`, …), so it
 * only matters for the other file types.
 */
export const findUploadConflicts = (
  picked: string[],
  existing: string[]
): string[] => {
  const existingKeys = new Set(
    existing.map((path) => safeNormalize(basename(path)))
  );

  const conflicts: string[] = [];
  const seen = new Set<string>();

  for (const name of picked) {
    const key = safeNormalize(basename(name));
    if (!existingKeys.has(key) || seen.has(key)) continue;
    seen.add(key);
    conflicts.push(name);
  }

  return conflicts;
};
